import { render, staticRenderFns } from "./EditEmail.vue?vue&type=template&id=dd83be94"
import script from "./EditEmail.vue?vue&type=script&lang=js"
export * from "./EditEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports